<template>
  <OverviewComponent />
</template>

<script>
import OverviewComponent from '../components/OverviewComponent.vue';

export default {
  components: {
    OverviewComponent,
  },
};
</script>
